import { BaseQueryFn } from '@reduxjs/toolkit/query/react';
import { HttpClient } from '../../services/http-client/http-client';
import { AxiosError } from 'axios';

interface AxiosQueryArgs {
  url: string;
  method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  data?: any;
  params?: Record<string, any>;
  cancelName?: string; // optional cancel token name
}

const axiosBaseQuery = (baseUrl: string): BaseQueryFn<AxiosQueryArgs, unknown, unknown> => async ({ url, method, data, params, cancelName }) => {
    try {
      // Create the request using your HttpClient
      const request = HttpClient.instance.createRequest({
        baseURL: baseUrl || HttpClient.instance._client.defaults.baseURL,
        url,
        method,
        data,
        params,
        ...(cancelName ? { signal: HttpClient.instance.getCancelToken(cancelName).signal } : {}),
      });

      const result = await HttpClient.instance.request(request);

      return { data: result.data };
    } catch (error) {
       throw error;
    }
  };

export default axiosBaseQuery;